import type { EligibilitySortColumnKey } from "@/billing/utils/eligibility-table-sort";
import {
  BILLING_PAYMENT_METHOD_LABEL_INSURANCE,
  BILLING_PAYMENT_METHOD_LABEL_SELF_PAY,
} from "@/shared/client-billing-payment-method";

/** Shared copy for the eligibility table refresh control (tooltip + aria-label). */
export const REFRESH_ELIGIBILITY_TABLE_LABEL = "Refresh eligibility table";

/** Select value for showing every payment method in the eligibility table. */
export const ELIGIBILITY_PAYMENT_METHOD_FILTER_ALL = "all";

export const ELIGIBILITY_PAYMENT_METHOD_FILTER_OPTIONS = [
  { value: ELIGIBILITY_PAYMENT_METHOD_FILTER_ALL, label: "All" },
  { value: BILLING_PAYMENT_METHOD_LABEL_SELF_PAY, label: BILLING_PAYMENT_METHOD_LABEL_SELF_PAY },
  { value: BILLING_PAYMENT_METHOD_LABEL_INSURANCE, label: BILLING_PAYMENT_METHOD_LABEL_INSURANCE },
];

/** Preset value for the default next-two-weeks eligibility appointment window. */
export const ELIGIBILITY_DATE_RANGE_PRESET_NEXT_TWO_WEEKS = "next-two-weeks";

/** Preset value for a user-chosen custom eligibility appointment window. */
export const ELIGIBILITY_DATE_RANGE_PRESET_CUSTOM = "custom";

export const ELIGIBILITY_DATE_RANGE_PRESET_NEXT_TWO_WEEKS_LABEL = "Next 2 weeks (including today)";

export const ELIGIBILITY_DATE_RANGE_PRESET_CUSTOM_LABEL = "Custom range";

export interface EligibilityTableColumn {
  key: EligibilitySortColumnKey | "actions";
  label: string;
  /** Column text alignment. Defaults to left when omitted. */
  align?: "left" | "right";
  sortable: boolean;
}

export const ELIGIBILITY_TABLE_COLUMNS: EligibilityTableColumn[] = [
  { key: "client", label: "Client", sortable: true },
  { key: "appointment", label: "Appointment", sortable: true },
  { key: "type", label: "Type", sortable: true },
  { key: "provider", label: "Provider", sortable: true },
  { key: "paymentMethod", label: "Payment Method", sortable: true },
  { key: "insurance", label: "Insurance", sortable: true },
  { key: "coverageEnd", label: "Coverage End", sortable: true },
  { key: "lastVerified", label: "Last Verified", sortable: true },
  { key: "coverageStatus", label: "Coverage Status", sortable: true },
  { key: "actions", label: "Actions", align: "right", sortable: false },
];
